module.exports = __webpack_public_path__ + "static/media/jose-alejandro-cuffia-k1LNP6dnyAE-unsplash.3a629a6d.jpg";